import SectionHeader from "@/components/feature/SectionHeader";
import MangaCard from "@/components/feature/MangaCard";
import { mangaWorks } from "@/mocks/manga";

export default function HotSection() {
  const hotList = [...mangaWorks]
    .sort((a, b) => a.hot - b.hot)
    .slice(0, 8);

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          title="热门推荐"
          subtitle="百万读者都在看的爆款漫画，人气口碑双丰收"
          moreLink="/category/all"
          moreText="漫画"
        />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4">
          {hotList.map((work, index) => (
            <MangaCard key={work.id} work={work} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}